import { IAutomatedRemindersModel } from '@Shared/models';

import { Api as apiService } from '../api';

export abstract class AutomatedRemindersApi {
  static automatedRemindersApi: string = `/api/automated_reminders`;

  static createAutomatedReminder(automatedReminder: Partial<IAutomatedRemindersModel>): Promise<IAutomatedRemindersModel> {
    return apiService.responseToJSONAndToastError(apiService.post(`${AutomatedRemindersApi.automatedRemindersApi}`, automatedReminder));
  }

  static updateAutomatedReminder(
    automatedReminderId: string,
    automatedReminder: Partial<IAutomatedRemindersModel>
  ): Promise<IAutomatedRemindersModel[]> {
    return apiService.responseToJSONAndToastError(
      apiService.patch(`${AutomatedRemindersApi.automatedRemindersApi}/${automatedReminderId}`, automatedReminder)
    );
  }

  static getSingleAutomatedReminder(automatedReminderId: string): Promise<IAutomatedRemindersModel> {
    return apiService.responseToJSONAndToastError(apiService.get(`${AutomatedRemindersApi.automatedRemindersApi}/${automatedReminderId}`));
  }

  static getAllAutomatedReminder(): Promise<IAutomatedRemindersModel[]> {
    return apiService.responseToJSONAndToastError(apiService.get(`${AutomatedRemindersApi.automatedRemindersApi}`));
  }

  static deleteAutomatedReminder(automatedReminderId: string): Promise<IAutomatedRemindersModel[]> {
    return apiService.responseToJSONAndToastError(
      apiService.delete(`${AutomatedRemindersApi.automatedRemindersApi}/${automatedReminderId}`)
    );
  }
}
